
import { onMounted, ref, computed, reactive } from 'vue'
import { getStatusBarInfo, getClientCommonMessage } from '@/utils/nativeFn'
import { compareVersion } from '@/utils/compareVersion'
import store from '@/store/index'
import ActionBar from '@/components/NewActionBar.vue'
import QueAnalysis from '../QueAnalysisTile/index.vue'
export default {
  name: 'QuestionAnalysis',
  props: {
    index: { type: Number, default: 0 },
    sourceLocation: { type: String, default: 'null_source' },
    submitQestionMap: { type: Object, default: () => {} }
  },
  components: { ActionBar, QueAnalysis },
  emits: ['close'],
  setup(props, { emit }) {
    const myAnswer = ref([])
    const questionList = computed(() => store.getters['taskPaper/questionList'])
    const queResList = computed(() => store.getters['taskPaper/queResList'])
    const submitQestionMap = computed(() => props.submitQestionMap)

    const swipWrap = ref(null)
    const swipeBoxInner = ref(null)
    // let initialIndex = Number((props.index || '0') as string)
    const currentIndex = computed(() => props.index || 0)

    const actionBarInfo = reactive({ actionBarTitle: '答题解析', actionBarBg: '#ffffff' })
    const actionBarHeight = ref(79) // 默认actionBar高度
    const showActionBar = ref(false) // 是否开启 actionBar 默认false, 版本大于 1.7.0开启

    // 获取状态栏高度
    const getStatusBarHeight = () => {
      return new Promise((resolve) => {
        getStatusBarInfo({}, (res) => {
          actionBarHeight.value = 44 + res.height || 35
          resolve(true)
        })
      })
    }
    // 获取版本信息
    const getClientCommonMessageFn = () => {
      getClientCommonMessage({}, (res) => {
        const versionName = res.service_version_name
        if (compareVersion(versionName, '1.8.0') !== -1) {
          // 初始化弹窗
          // 获取状态栏高度 + 计算actionBar高度
          getStatusBarHeight().then(() => {
            showActionBar.value = true
          })
        }
      })
    }
    const goBack = () => emit('close')

    // 回到顶部
    const scrollTop = () => {
      swipWrap.value.scrollTop = 0
    }
    const preventDefaultEvent = () => false
    onMounted(() => getClientCommonMessageFn())
    return {
      actionBarInfo,
      actionBarHeight,
      questionList,
      currentIndex,
      swipeBoxInner,
      swipWrap,
      myAnswer,
      queResList,
      submitQestionMap,
      goBack,
      scrollTop,
      preventDefaultEvent,
      showActionBar
    }
  }
}
